import { render, staticRenderFns } from "./rosteringnowduty.vue?vue&type=template&id=2e120e94&scoped=true&"
import script from "./rosteringnowduty.vue?vue&type=script&lang=js&"
export * from "./rosteringnowduty.vue?vue&type=script&lang=js&"
import style0 from "./rosteringnowduty.vue?vue&type=style&index=0&id=2e120e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e120e94",
  null
  
)

export default component.exports